import React from 'react';
import GradeLevelPie from "./gradeLevelPie";
import GradeLevelBarChart from "./gradeLevelBarChart";
import GradeLevelMTSSArray from "./gradeLevelMTSSArray";

function GradeLevelSummaryBlock({user, data}) {
    return (
        <div className={'flex flex-col border-[1px] border-dutch_white-100 rounded m-1'}>
        <div className={'flex-col bg-columbia_blue-800 m-1 rounded p-2'}>
            <p className={'font-bold text-columbia_blue-100 text-3xl'}>Grade {data.grade}</p>
            {data.pie === "No Data in Timeframe" ? <div className={'rounded bg-columbia_blue text-columbia_blue-900 py-12'}>
                <p className={"w-3/4 mx-auto font-bold text-lg"}>No assessments assigned between selected</p>
                <p className={'w-3/4 mx-auto mt-2'}>Reselect dates and update to find data</p>
            </div> : <>
            <GradeLevelPie data={data.pie} />
            <GradeLevelBarChart data={data.bar} />
            </>}
        </div>
        <div className={'w-full bg-columbia_blue-900 px-2 mt-4 rounded-b pb-2'}>
            <GradeLevelMTSSArray user={user} data={data.mtss} />
        </div>
        </div>
    );
}

export default GradeLevelSummaryBlock;